const datasetLinkActions = {
  FETCH_DATASET_LINKS: 'FETCH_DATASET_LINKS',
  FETCH_DATASET_LINKS_SUCCESS: 'FETCH_DATASET_LINKS_SUCCESS',
  FETCH_DATASET_LINKS_ERROR: 'FETCH_DATASET_LINKS_ERROR',
};

export default datasetLinkActions;
